module.exports = __webpack_public_path__ + "images/FUSA_icons/095-list-1.b9693ac12049a6d95795c8775cf0e9a5.svg";